/**
 * 레퍼런스(api): https://github.kakaocorp.com/kakaopage/api/blob/c7b2307cf7f9761b8db7501e31c75d383a2f43a4/api/src/main/java/com/kakaopage/api/model/GotchaMainResponse.java#L44
 */
export enum RouletteStatusVo {
  Error = 'E01', // 서버에러
  Fail = 'E02', // 캐시지급실패
  TicketFail = 'E03', // 대여권지급실패
  Duplicate = 'E04', // 중복된요청
  BudgetCrunch = 'E05', // 빌링 예산 부족으로 실패
  First = 'S01', // 뽑기가능
  Expire = 'S02', // 유효기간지남
  Already = 'S03', // 이미뽑음
  Noauth = 'S04', // 권한없음 (Deprecated)
  Disable = 'S05', // 비활성화
  // 아래는 웹에서만 사용하는 값 (API에서 주는 값 아님)
  WaitRedeemResult = 'W00', // redeem draw 결과를 기다리는 중
  Draw = 'D00', // draw 중
  Success = 'S00', // draw 성공
  UnknownApiStatus = 'U00', // API에러가 발생했지만, 정의하지 않은 에러인 경우
}
